/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import { storeUserConfig } from '@vantiva-sa/homesight_humaui/Store/dataStore';
import { useApiQuery } from './useApiQuery';

const TWO_HOURS_MS = 2 * 60 * 60 * 1000;

const useConfig = ({ useruuid }) => {
  const dispatch = useDispatch();
  const trans = useSelector(translator);
  const userConfigApi = useSelector((state) => state.apis.userConfigApi);

  return useApiQuery(
    ['getMergedConfig', useruuid],
    () =>
      new Promise((resolve, reject) => {
        const errorCallback = (error) => {
          console.error('Error fetching user config:', error);
          reject(error);
        };

        const successCallback = (data) => {
          const config = data?.config ?? {};
          dispatch(storeUserConfig({ userConfig: config, useruuid }));
          resolve(config);
        };

        try {
          userConfigApi.getMergedConfigByUserId(
            useruuid,
            apiCallback({
              translator: trans,
              failCallback: errorCallback,
              errorCallback,
              successCallback,
            })
          );
        } catch (error) {
          errorCallback(error);
        }
      }),
    { enabled: !!useruuid, staleTime: TWO_HOURS_MS, gcTime: TWO_HOURS_MS }
  );
};

export default useConfig;
